import * as React from "react";
import { Root } from "@radix-ui/react-form";
import { FormHTMLAttributes } from "react";

interface FormRootProps extends FormHTMLAttributes<HTMLFormElement> {
  size: "small" | "medium" | "large" | "full";
  children: React.ReactNode;
  onSubmitHandler: React.FormEventHandler<HTMLFormElement>;
}

export const FormRoot = React.forwardRef<HTMLFormElement, FormRootProps>(function FormRoot(
  { size, children, onSubmitHandler, ...props },
  ref,
) {
  const sizeClass = {
    small: "w-[260px]",
    medium: "w-[360px]",
    large: "w-[460px]",
    full: "w-full",
  };

  return (
    <Root ref={ref} className={sizeClass[size]} onSubmit={onSubmitHandler} {...props}>
      {children}
    </Root>
  );
});

FormRoot.displayName = "FormRoot";
